@use '@design/design-tokens/typography/typography' as *;

.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  & + &:not(:last-child) {
    margin-top: 80px;
  } 
  
  &:last-child {
    margin-top: 40px;
  }
  
}

.header {
  display: flex;
  flex-direction: column;
}

.title {
  @include typography-v2-title-md;
  color: var(--text-default);
}

.subtitle {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}

.cards {
  display: flex;
  flex-direction: column;
  gap: 12px; 
  width: 100%;
}
